import { api, handleApiCall, ApiResult } from './api';
import { ExpenseType } from '../types/homeExpenses';

export interface ImportValidationResult {
  isValid: boolean;
  errors: string[];
  warnings: string[];
  totalRows: number;
  detectedHeaders: string[];
  previewRecords: ImportedRecord[];
}

export interface ImportedRecord {
  rowNumber: number;
  date: string;
  group: string;
  amount: number;
  account: string;
  observations?: string;
  isSuccess: boolean;
  errorMessage?: string;
}

export interface ImportResult {
  success: boolean;
  message: string;
  totalRecords: number;
  successfulImports: number;
  failedImports: number;
  errors: string[];
  warnings: string[];
  importedRecords: ImportedRecord[];
}

export interface ExportOptions {
  startDate?: string;
  endDate?: string;
  groups: string[];
  accounts: string[];
  includeIncome: boolean;
  includeExpenses: boolean;
  format: 'Csv' | 'Xlsx';
  type?: ExpenseType;
}

export const homeExpenseImportExportApi = {
  // Validate import file
  async validateImportFile(file: File): Promise<ImportValidationResult> {
    const formData = new FormData();
    formData.append('file', file);

    return handleApiCall(() => api.post<ApiResult<ImportValidationResult>>('/api/HomeExpenseImportExport/validate', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }));
  },

  // Import expenses from file
  async importHomeExpenses(file: File, clearExistingData: boolean = false): Promise<ImportResult> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('clearExistingData', clearExistingData.toString());

    return handleApiCall(() => api.post<ApiResult<ImportResult>>('/api/HomeExpenseImportExport/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }));
  },

  // Export expenses
  async exportHomeExpenses(options: ExportOptions): Promise<Blob> {
    const response = await api.post('/api/HomeExpenseImportExport/export', options, {
      responseType: 'blob'
    });

    return response.data as Blob;
  },

  // Download specific template
  async downloadTemplate(format: 'Csv' | 'Xlsx'): Promise<Blob> {
    const response = await api.get(`/api/HomeExpenseImportExport/templates/${format}`, {
      responseType: 'blob'
    });

    return response.data as Blob;
  }
};
